import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { AuthService, Container } from '../../../../symphony';

import {
	questionsFilerTypeAlias,
	QUESTIONS_LIST_COUNT,
	SlDiscussContext,
} from '../../global-constants';
import { SlDataService } from '../../services/sl-data.service';
import { AskQuestion } from '../AskQuestion/AskQuestion';
import { ActionType, RequestType } from '../../global-interface';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { PaginationItem } from '../../../../shared/public/SlPagination/types';
import { SlPagination } from '../../../../shared/public/SlPagination/SlPagination';

export function QuestionsPaginationContainer() {
	const { actions$ } = Container.take(SlDiscussContext, SlActions);
	const isLoggedIn = Container.take('global', AuthService).isLoggedIn();
	const [searchParams] = useSearchParams();
	const questionsListFilter = searchParams.get('ordering')
		|| Object.values(questionsFilerTypeAlias)[0];
	const isMyAnswers = questionsListFilter === 'MyAnswers';
	const isMyQuestions = questionsListFilter === 'MyQuestions';
	const {
		questionsList$: questionsList,
		questionsListCount$: questionsListCount,
	} = useContainerData(SlDiscussContext, SlDataService, [
		'questionsList$',
		'questionsListCount$',
	]);

	if (!questionsList || ((isMyAnswers || isMyQuestions) && !isLoggedIn)) return null;

	const handleItemClick = (item: PaginationItem) => {
		actions$.next({
			type: ActionType.OnPaginationClick,
			requestType: RequestType.Parallel,
			data: item,
		});
	};

	return (
		<>
			<AskQuestion parentComponent="QuestionsPaginationContainer" />
			<SlPagination
				totalCount={questionsListCount}
				rowsPerPage={QUESTIONS_LIST_COUNT}
				onItemClick={handleItemClick}
			/>
		</>
	);
}
